const operationTypes = [
    {
        id: 1,
        label: 'Przychód - tankowanie zbiornika',
        value: 'income'
    },
    {
        id: 2,
        label: 'Rozchód - pobieranie materiału',
        value: 'expenditure'
    }
];

export {operationTypes}
